import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';
import { CreateChannelBody, ChannelResponse } from '../types/backend';
import { addNewChannelToCache } from '../utils/updateChannelCache';

export type CreateChannelDTO = CreateChannelBody;

const createChannel = async (
  data: CreateChannelDTO
): Promise<ChannelResponse> => {
  return axios.post(`${MESSAGING_API_BASE}/channels`, data);
};

export const useCreateChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateChannelDTO) => createChannel(data),
    onSuccess: (response) => {
      // Add newly created channel to cache at the top
      if (response) {
        // Convert ChannelResponse to ChannelListItemResponse format
        const channelListItem = {
          ...response,
          'read-only': false, // New channels created by user are not read-only
          'last-message-at': new Date().toISOString(), // Set current timestamp for sorting
        };
        addNewChannelToCache(queryClient, channelListItem);

        // Also set individual channel query data to prevent duplicate API call
        // when user immediately opens the newly created channel
        queryClient.setQueryData(
          messagingQueryKeys.channel(response.id),
          response
        );
      }

      // Note: We don't invalidate here because that would override our cache update
      // The WebSocket event will handle syncing across clients
    },
  });
};
